// @core/api/endpoints/document/update_numbering_scheme.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  NumberingSchemeResponse,
  UpdateNumberingSchemeRequest,
} from '../../../types/document';

const BASE_PATH = '/document';

/**
 * Update numbering scheme
 * Updates an existing numbering scheme. Changing format does not renumber existing documents.
 */
export async function UpdateNumberingScheme(
  scheme_id: string,
  data: UpdateNumberingSchemeRequest,
  options?: RequestOptions
): Promise<NumberingSchemeResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/numbering-schemes/:scheme_id`;
  requestPath = requestPath.replace(':scheme_id', encodeURIComponent(scheme_id));
  const requestOptions = options;
  return client.put<NumberingSchemeResponse>(requestPath, data, requestOptions);
}
